/**
 * The type of health measurement
 */
export enum HealthMeasurementType {
  /**
   * The system could not recognized the type of health measurement.
   */
  Unknown = 'unknown',

  /**
   * A healthy internal body temperature falls within a narrow window where the average person has a baseline temperature between 37°C.
   */
  BodyTemperature = 'body-temperature',

  /**
   * Human body weight is a person's mass or weight. Strictly speaking, body weight is the measurement of weight without items located on the person.
   */
  BodyWeight = 'body-weight',

  /**
   * Human height or stature is the distance from the bottom of the feet to the top of the head in a human body, standing erect.
   */
  BodyHeight = 'body-height',

  /**
   * A normal resting heart rate for adults ranges from 60 to 100 beats per minute.
   */
  HeartRate = 'heart-rate',

  /**
   * A reading indicates what percentage of your blood is saturated, known as the SpO2 level.
   */
  BloodOxygen = 'blood-oxygen',

  /**
   * Blood pressure is the force of blood pushing against the walls of the arteries as your heart pumps blood.
   */
  BloodPressure = 'blood-pressure',

  /**
   * Number of times a person breathes per minute.
   */
  RespiratoryRate = 'respiratory-rate',

  /**
   * Form of sugar that the body can absorb after breaking down the food that has been eaten.
   */
  BloodGlucose = 'blood-glucose',

  /**
   * Body fat percentage is the weight of fat in a body, compared with the total body weight, which includes muscles, bones, water and so on.
   */
  BodyFatPercentage = 'body-fat-percentage',

  /**
   * Body muscle percentage is the weight of muscle in a body, compared with the total body weight, which includes fat, bones, water and so on.
   */
  BodyMusclePercentage = 'body-muscle-percentage',

  /**
   * Body water percentage is the weight of water in a body, compared with the total body weight, which includes fat, bones, muscle and so on.
   */
  BodyWaterPercentage = 'body-water-percentage',

  /**
   * Natriuretic peptide tests measure levels of BNP or NT-proBNP in the blood. BNP and NT-proBNP are substances made by the heart.
   */
  NatriureticPeptideTest = 'natriuretic-peptide-test',

  /**
   * Step count is the number of steps taken throughout the day.
   */
  Steps = 'steps',

  /**
   * Estimation of time in bed and time asleep.
   */
  Sleep = 'sleep',
}
